import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {onMounted, nextTick} from 'vue';
    import {storeToRefs} from 'pinia';
    import {AsideMenu, ExistingUserOnboardingTour, HeaderMenu, NewUserOnboardingModal, useDisplayMode} from '@/logged/features';
    import {setCssVariable} from '@/logged/common/utils';
    import {useOnboardingNewUser} from '@/logged/features/onboarding-new-user';
    import {useOnboardingExistingUser} from '@/logged/features/onboarding-existing-user';
    import {useAppContext} from './config';
    import {MaltFooter} from './features/footer';
    import {useUser} from './features/user';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const displayModeStore = useDisplayMode();

    const appContext = useAppContext();

    const userStore = useUser();

    const onBoardingStore = useOnboardingNewUser();
    const onBoardingExistingUserStore = useOnboardingExistingUser();

    const {isDisplayModeFunnel} = storeToRefs(displayModeStore);

    setCssVariable('--aside-menu-width', '72px');
    setCssVariable('--aside-menu-left', '0px');
    setCssVariable('--header-menu-height', '70px');
    setCssVariable('--header-menu-item-margin-top', '0px');
    setCssVariable('--layout-padding-left', '72px');
    setCssVariable('--layout-padding-top', '70px');
    setCssVariable('--header-height', '70px !important');

    /** This variable purpose is to let a property check if the navbar is present on legacy pages and fallback on an other default value
     * It's set at 0px so it doesn't impact calculations
     */
    setCssVariable('--navbar-logged-loaded', '0px');

    document.body.classList.add('navbar-logged');

    onMounted(() => {
        document.body.style.transition = 'padding 0.3s ease';
        nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('aside-menu-loaded'));
            });
        });
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(HeaderMenu)),
    (!_unref(isDisplayModeFunnel))
      ? (_openBlock(), _createBlock(_unref(AsideMenu), { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(appContext).loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_unref(isDisplayModeFunnel) && _unref(onBoardingStore).showNewUserOnboardingModal && _unref(userStore).hasSelectedClientIdentity)
            ? (_openBlock(), _createBlock(_unref(NewUserOnboardingModal), { key: 0 }))
            : _createCommentVNode("", true),
          (!_unref(isDisplayModeFunnel) && _unref(onBoardingExistingUserStore).showExistingUserOnboardingTour)
            ? (_openBlock(), _createBlock(_unref(ExistingUserOnboardingTour), { key: 1 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_unref(MaltFooter))
  ], 64))
}
}

})